import type { CSSProperties } from 'react';

interface ScoreBadgeProps {
  score: number;
  label?: string;
  size?: 'sm' | 'md' | 'lg';
}

function getColor(score: number): { bg: string; text: string; border: string } {
  if (score >= 71) return { bg: '#d1fae5', text: '#065f46', border: '#6ee7b7' };
  if (score >= 41) return { bg: '#fef3c7', text: '#92400e', border: '#fcd34d' };
  return { bg: '#fee2e2', text: '#991b1b', border: '#fca5a5' };
}

const sizeMap = {
  sm: { fontSize: '11px', padding: '2px 6px', minWidth: '32px' },
  md: { fontSize: '13px', padding: '3px 8px', minWidth: '40px' },
  lg: { fontSize: '15px', padding: '4px 12px', minWidth: '48px' },
};

export function ScoreBadge({ score, label, size = 'md' }: ScoreBadgeProps) {
  const { bg, text, border } = getColor(score);
  const sz = sizeMap[size];

  const style: CSSProperties = {
    display: 'inline-flex',
    flexDirection: 'column',
    alignItems: 'center',
    backgroundColor: bg,
    color: text,
    border: `1px solid ${border}`,
    borderRadius: '6px',
    fontWeight: 700,
    fontFamily: 'monospace',
    lineHeight: 1.2,
    ...sz,
  };

  return (
    <span style={style} title={label ? `${label}: ${score}` : `Score: ${score}`}>
      {score}
      {label && (
        <span
          style={{
            fontSize: '9px',
            fontFamily: 'sans-serif',
            fontWeight: 500,
            textTransform: 'uppercase',
            letterSpacing: '0.04em',
            opacity: 0.8,
          }}
        >
          {label}
        </span>
      )}
    </span>
  );
}
